import React from 'react';
import { VMInstanceType } from '../../../types/vm.type';

interface InstanceTypeCardProps {
  instance: VMInstanceType;
  selected: boolean;
  onClick: () => void;
}

const InstanceTypeCard: React.FC<InstanceTypeCardProps> = ({ instance, selected, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-between p-4 border-2 rounded-lg transition-all ${
        selected
          ? 'border-black dark:border-white bg-gray-50 dark:bg-gray-700'
          : 'border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500'
      }`}
    >
      <div className="text-left">
        <div className="flex items-center gap-2 mb-1">
          <p className="font-semibold text-gray-900 dark:text-white font-mono text-blue-600 dark:text-blue-400">
            {instance.kubiyName}
          </p>
          <span className="text-xs text-gray-500 dark:text-gray-400">({instance.awsType})</span>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {instance.cpu} • {instance.ram}
        </p>
      </div>
      <div className="text-right">
        <p className="text-lg font-bold text-gray-900 dark:text-white">{instance.price}</p>
        <p className="text-xs text-gray-500 dark:text-gray-400">per hour</p>
      </div>
    </button>
  );
};

export default InstanceTypeCard;
